import axios from 'axios'

export default class NuxtRequest {

    constructor (config) {

        var defaultConfig = Object.assign({
            baseURL: process.env.VUE_APP_NUXT_API_BASE_URL,
            responseType: 'json',
            headers: {
                'Content-Type': 'application/json'
            }
        }, config)

        this.nuxtRequest = axios.create(defaultConfig)
    }

    post (url, formData, options = {}) {
        return this.nuxtRequest.post(url, formData, options)
    }
}
